import { FC } from 'react'
import { Box, Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import { validFor } from '@/theme/validFor'
import { LandingPageSection } from '@/network/graphql.g'
import Link from '@/components/atoms/link'
import {
  getImageUrlManufacturer,
  getImageUrlMobileManufacturer
} from '@/components/molecules/blackFriday/getImageUrl'

import ProductCard from '@/components/organisms/productCard/productCard'
import {
  ShowProductModal,
  withProductDetailPopup
} from '@/HOC/withProductDetailPopup'
import { ProductCardMode } from '@/components/organisms/productCard/productCardMode'
import ProductsSlider, {
  ProductSlide,
  SliderDirection
} from '@/components/organisms/productsSlider'
import { ArrowsPosition } from '@/components/organisms/productsSlider/productsSlider'
import { breakpoints } from '@/theme/breakpoints'
import { SlideItemsCount } from '@/components/organisms/productsSlider/horizontalTitledProductsSlider'
import { v4 as uuidv4 } from 'uuid'

type BlackFridayCategoriesProps = {
  blackFridayManufacturerSection: LandingPageSection[]
  showProductModal?: ShowProductModal
  slidesToShow?: SlideItemsCount
}

const BlackFridayManufacturerContainer: FC<BlackFridayCategoriesProps> = ({
  blackFridayManufacturerSection,
  showProductModal,
  slidesToShow = { desktop: 5.5, tablet: 3.5, mobile: 2.5 }
}) => {
  return (
    <Box>
      {blackFridayManufacturerSection.map((manufacturer) => (
        <StyledManufacturerSection key={uuidv4()}>
          <Box>
            <Link href={manufacturer.link}>
              <ManufacturerContainer manufacturer={manufacturer.position} />
            </Link>
            {manufacturer.link2 !== null && (
              <Flex>
                <StyledHalfLink href={manufacturer.link2} />
                <StyledHalfLink href={manufacturer.link} />
              </Flex>
            )}
          </Box>
          <Box mt={3}>
            <ProductsSlider
              slidesPerGroup={1}
              fillArrowBackground={true}
              arrowsPosition={ArrowsPosition.Inside}
              sliderDirection={SliderDirection.horizontal}
              spaceBetween={10}
              arrowsTopPercent={45}
              breakpoints={{
                [breakpoints.desktop.min]: {
                  slidesPerView: slidesToShow.desktop
                },
                [breakpoints.tablet.min]: {
                  slidesPerView: slidesToShow.tablet
                },
                [breakpoints.mobile.min]: {
                  slidesPerView: slidesToShow.mobile
                }
              }}
            >
              {manufacturer.products.map((item, offset) => (
                <ProductSlide key={offset}>
                  <ProductCard
                    key={item.id}
                    mode={ProductCardMode.recommended}
                    onAddToCart={showProductModal}
                    product={item}
                    position={offset + 1}
                    list={'blackFriday.customProduct'}
                  />
                </ProductSlide>
              ))}
            </ProductsSlider>
          </Box>
        </StyledManufacturerSection>
      ))}
    </Box>
  )
}

export default withProductDetailPopup(BlackFridayManufacturerContainer)

const ManufacturerContainer = styled(Flex)`
  background-image: ${(props) =>
    props.manufacturer &&
    `url(${getImageUrlManufacturer(props.manufacturer)})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 280px;
  margin-top: 40px;
  ${validFor.tablet`
    background-size: contain;
    margin-top: 0px;
    height: 200px;
  `}
  ${validFor.mobile`
    background-image: ${(props) =>
      props.manufacturer &&
      `url(${getImageUrlMobileManufacturer(props.manufacturer)})`};
    background-size: contain;
    margin-top: 0px;
  `}
`

const StyledManufacturerSection = styled(Box)`
  &:last-child {
    margin-bottom: 30px;
  }
`
const StyledHalfLink = styled(Link)`
  width: 50%;
  height: 280px;
  margin-top: -280px;
  ${validFor.tablet`
    height: 200px;
    margin-top: -200px; 
  `}
`
